import types from './types';

export const setActivePage = page => ({
	type: types.SET_ACTIVE_PAGE,
	payload: page
});

export const setLanguage = language => ({
	type: types.SET_LANGUAGE,
	payload: language
});
